import { render } from "./MaterialCover.vue?vue&type=template&id=27eaf5b0&scoped=true"
import script from "./MaterialCover.vue?vue&type=script&lang=js"
export * from "./MaterialCover.vue?vue&type=script&lang=js"

import "./MaterialCover.vue?vue&type=style&index=0&id=27eaf5b0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27eaf5b0"]])

export default __exports__